import { isMemberSignedIn, loadMemberRewards } from '@vista/omnichannel-components-domain';
import { useLoadAction } from '@vista-digital/react-tools';
import { useCallback } from 'react';
/**
 * Loads member rewards if the member is signed in.
 * Will load rewards if the member signs in after the initial render.
 */
export const useMemberRewards = () => {
    const isSignedIn = isMemberSignedIn();
    const loadAction = useCallback(async () => {
        if (!isSignedIn)
            return;
        await loadMemberRewards();
    }, [isSignedIn]);
    return useLoadAction(loadAction);
};
